export default "__VITE_ASSET__DnTmL5P___"